import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import Breadcrumb from '../common/breadcrumb';
import AuthService from "../services/auth.service";
import ApiService from "../services/api.service";
import Moment from 'moment';
import { CSVLink } from 'react-csv';
import { SortableTh, sortRows, nextSort } from '../common/sortable-th';
import { StatCardsGrid } from '../common/stat-cards';
import { DateRangeInput } from '../common/date-range-input';

function today() {
    return Moment().format('YYYY-MM-DD');
}

function fmtMoney(val) {
    if (val === null || val === undefined || val === '') return '—';
    const num = parseFloat(val);
    if (isNaN(num)) return '—';
    return 'S/ ' + num.toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

const TIPO_COLORS = {
    'GANANCIA CASH': { bg: '#d4edda', color: '#155724' },
    'AGREGAR CASH': { bg: '#d4edda', color: '#155724' },
    'COMPRA CON CASH': { bg: '#f8d7da', color: '#721c24' },
};

function tipoBadge(tipo) {
    const s = TIPO_COLORS[tipo] || { bg: '#e2e3e5', color: '#383d41' };
    return (
        <span style={{ background: s.bg, color: s.color, borderRadius: 10, padding: '2px 9px', fontSize: 12, fontWeight: 600, whiteSpace: 'nowrap' }}>
            {tipo}
        </span>
    );
}

const CASH_HEADERS = [
    { label: 'Id', key: 'Id' },
    { label: 'Usuario', key: 'Usuario' },
    { label: 'Tipo', key: 'Tipo' },
    { label: 'Fecha', key: 'FechaLabel' },
    { label: 'Detalle', key: 'Detalle' },
    { label: 'Añadido por', key: 'AddedBy' },
    { label: 'Monto', key: 'Monto' },
];

function csvFilename(from, to) {
    return `movimientos_cash_${from}_a_${to}.csv`;
}

export class Ver_all_cash_user extends Component {
    constructor(props) {
        super(props);
        this.applyDateRange = this.applyDateRange.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.onChangeFilter = this.onChangeFilter.bind(this);
        this.state = {
            loading: false,
            results: [],
            temp: [],
            filter: '',
            page: 1,
            sort: { key: 'Fecha', dir: 'desc' },
            dateFrom: today(),
            dateTo: today(),
        };
    }

    componentDidMount() {
        this.getDataCash();
    }

    applyDateRange(from, to) {
        this.setState({ dateFrom: from, dateTo: to }, () => this.getDataCash());
    }

    handleSort(key) {
        this.setState((prev) => ({
            sort: nextSort(prev.sort, key),
            page: 1,
        }));
    }

    getDataCash() {
        const user = AuthService.getCurrentUser();
        this.setState({ loading: true });
        const { dateFrom, dateTo } = this.state;

        ApiService.getReportCashUser(user.token, { from: dateFrom, to: dateTo }).then(
            (res) => {
                if (res && res.status === 'success') {
                    const items = (res.data || []).map(function (row) {
                        return {
                            Id: row.id,
                            id_user: row.id_user,
                            Usuario: row.User ? row.User.full_name : '—',
                            Tipo: row.operation_type,
                            Fecha: row.approval_date,
                            FechaLabel: row.approval_date ? Moment(row.approval_date).format('DD/MM/YYYY') : '—',
                            Detalle: row.detail,
                            // Quién lo agregó -- Sistema si el movimiento lo
                            // generó el backend solo (compra, ganancia, bono),
                            // o el nombre del admin si fue "Añadir Crédito".
                            AddedBy: row.Admin ? (row.Admin.full_name || row.Admin.email) : 'Sistema',
                            Monto: parseFloat(row.amount_cash) || 0,
                        };
                    });
                    this.setState({ loading: false, results: items, temp: items, page: 1 });
                } else {
                    this.setState({ loading: false, results: [], temp: [] });
                }
            },
            () => {
                this.setState({ loading: false, results: [], temp: [] });
            }
        );
    }

    onChangeFilter(e) {
        const val = e.target.value;
        this.setState({ filter: val, page: 1 });

        const needle = val.toLowerCase();
        const rows = this.state.temp.filter(function (row) {
            return ['Usuario', 'Tipo', 'Detalle', 'FechaLabel', 'AddedBy'].some(function (key) {
                return row[key] && row[key].toString().toLowerCase().indexOf(needle) > -1;
            });
        });
        this.setState({ results: rows });
    }

    renderPagination(total, page, pageSize, onPageChange) {
        const totalPages = Math.ceil(total / pageSize);
        if (totalPages <= 1) return null;
        const from = (page - 1) * pageSize + 1;
        const to = Math.min(page * pageSize, total);
        return (
            <div style={{
                display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between',
                padding: '10px 16px', borderTop: '1px solid #f0f0f0', gap: 8,
                background: '#fafafa', fontSize: 13, color: '#666',
            }}>
                <span style={{ fontSize: 12, color: '#aaa' }}>{from}–{to} de {total}</span>
                <div style={{ display: 'flex', gap: 6 }}>
                    <button
                        disabled={page === 1}
                        onClick={() => onPageChange(page - 1)}
                        style={{
                            border: '1px solid #ddd', borderRadius: 6, padding: '4px 12px',
                            background: page === 1 ? '#f4f4f4' : '#fff',
                            color: page === 1 ? '#ccc' : '#333',
                            cursor: page === 1 ? 'default' : 'pointer', fontSize: 13,
                        }}
                    >
                        <i className='fa fa-chevron-left' />
                    </button>
                    <span style={{ padding: '4px 10px', fontSize: 13, color: '#555' }}>{page} / {totalPages}</span>
                    <button
                        disabled={page === totalPages}
                        onClick={() => onPageChange(page + 1)}
                        style={{
                            border: '1px solid #ddd', borderRadius: 6, padding: '4px 12px',
                            background: page === totalPages ? '#f4f4f4' : '#fff',
                            color: page === totalPages ? '#ccc' : '#333',
                            cursor: page === totalPages ? 'default' : 'pointer', fontSize: 13,
                        }}
                    >
                        <i className='fa fa-chevron-right' />
                    </button>
                </div>
            </div>
        );
    }

    renderResults() {
        const { results, page, sort, loading } = this.state;
        if (loading) return <div style={{ padding: 16, color: '#888' }}>Cargando...</div>;
        if (results.length === 0) return <div style={{ padding: 16, color: '#888' }}>No hay movimientos en el rango seleccionado.</div>;

        const PAGE_SIZE = 50;
        const sorted = sortRows(results, sort);
        const totalPages = Math.max(1, Math.ceil(sorted.length / PAGE_SIZE));
        const currentPage = Math.min(page, totalPages);
        const paginated = sorted.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);

        const headers = [
            { label: 'Id', key: 'Id', align: 'left' },
            { label: 'Usuario', key: 'Usuario', align: 'left' },
            { label: 'Tipo', key: 'Tipo', align: 'left' },
            { label: 'Fecha', key: 'Fecha', align: 'left' },
            { label: 'Detalle', key: 'Detalle', align: 'left' },
            { label: 'Añadido por', key: 'AddedBy', align: 'left' },
            { label: 'Monto', key: 'Monto', align: 'right' },
        ];

        return (
            <div style={{ border: '1px solid #ebebeb', borderRadius: 10, overflow: 'hidden' }}>
                <div style={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                        <thead>
                            <tr style={{ background: '#f8f9fa', borderBottom: '2px solid #ebebeb' }}>
                                {headers.map((h) => (
                                    <SortableTh key={h.key} header={h} sort={sort} onSort={this.handleSort} style={{ textAlign: h.align }} />
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {paginated.map((item) => (
                                <tr
                                    key={item.Id}
                                    style={{ borderBottom: '1px solid #f4f4f4' }}
                                    onMouseEnter={(e) => (e.currentTarget.style.background = '#f8fbff')}
                                    onMouseLeave={(e) => (e.currentTarget.style.background = '')}
                                >
                                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', fontWeight: 500, textAlign: 'left' }}>{item.Id}</td>
                                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', textAlign: 'left' }}>
                                        <Link
                                            to={`${process.env.PUBLIC_URL}/customer-profile/${item.id_user}`}
                                            style={{ color: '#007bff', fontWeight: 500 }}
                                        >
                                            {item.Usuario}
                                        </Link>
                                    </td>
                                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', textAlign: 'left' }}>{tipoBadge(item.Tipo)}</td>
                                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', color: '#666', textAlign: 'left' }}>{item.FechaLabel}</td>
                                    <td style={{ padding: '9px 12px', color: '#666', textAlign: 'left' }}>{item.Detalle}</td>
                                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', color: item.AddedBy === 'Sistema' ? '#aaa' : '#666', textAlign: 'left' }}>{item.AddedBy}</td>
                                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', fontWeight: 700, textAlign: 'right' }}>{fmtMoney(item.Monto)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {this.renderPagination(sorted.length, currentPage, PAGE_SIZE, (p) => this.setState({ page: p }))}
            </div>
        );
    }

    render() {
        const { results, sort, dateFrom, dateTo } = this.state;
        const sortedResults = sortRows(results, sort);

        let cashGranted = 0;
        let cashUsed = 0;
        for (const row of results) {
            if (row.Tipo === 'COMPRA CON CASH') cashUsed += row.Monto;
            else if (row.Tipo === 'GANANCIA CASH' || row.Tipo === 'AGREGAR CASH') cashGranted += row.Monto;
        }
        const distinctUsers = new Set(results.map((r) => r.id_user)).size;

        const stats = [
            { label: 'Cash otorgado', value: fmtMoney(cashGranted), icon: 'fa-gift', color: '#20c997' },
            { label: 'Cash usado', value: fmtMoney(cashUsed), icon: 'fa-credit-card', color: '#d63384' },
            { label: 'Movimientos', value: results.length, icon: 'fa-list', color: '#0d6efd' },
            { label: 'Usuarios con movimiento', value: distinctUsers, icon: 'fa-users', color: '#8e44ad' },
        ];

        return (
            <Fragment>
                <Breadcrumb title="Créditos" parent="Digital" />

                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card" style={{ marginBottom: 16 }}>
                                <div className="card-body" style={{ padding: '12px 16px' }}>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 10 }}>
                                        <span style={{ fontSize: 13, fontWeight: 600, color: '#555', whiteSpace: 'nowrap' }}>
                                            Filtrar por fecha
                                        </span>
                                        <DateRangeInput
                                            from={this.state.dateFrom}
                                            to={this.state.dateTo}
                                            onApply={this.applyDateRange}
                                        />
                                    </div>
                                </div>
                            </div>

                            <StatCardsGrid stats={stats} columns={4} />

                            <div className="card" style={{ boxShadow: 'none', border: '1px solid #ebebeb' }}>
                                <div
                                    className="card-header"
                                    style={{
                                        display: 'flex', flexWrap: 'wrap', alignItems: 'center',
                                        justifyContent: 'space-between', gap: 10,
                                    }}
                                >
                                    <h5 style={{ margin: 0 }}>Movimientos del periodo</h5>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 10 }}>
                                        <input
                                            placeholder="Buscar..."
                                            name="filter"
                                            type="text"
                                            className="form-control"
                                            autoComplete="off"
                                            onInput={this.onChangeFilter}
                                            style={{
                                                flex: '1 1 180px', minWidth: 140, maxWidth: 260,
                                                height: 32, boxSizing: 'border-box', padding: '4px 10px',
                                            }}
                                        />
                                        {results.length > 0 && (
                                            <CSVLink
                                                className="btn btn-outline-primary btn-sm"
                                                data={sortedResults}
                                                headers={CASH_HEADERS}
                                                filename={csvFilename(dateFrom, dateTo)}
                                                style={{
                                                    display: 'inline-flex', alignItems: 'center', height: 32,
                                                    flexShrink: 0, whiteSpace: 'nowrap', boxSizing: 'border-box',
                                                }}
                                            >
                                                <i className="fa fa-file-excel-o" style={{ marginRight: 6 }} />
                                                Exportar
                                            </CSVLink>
                                        )}
                                    </div>
                                </div>
                                <div className="card-body" style={{ padding: 0 }}>
                                    {this.renderResults()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default Ver_all_cash_user;
